import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as Theme from "../../../app/Theme";

import TButton from "../../common/TButton";

import {

}  from "../NonVisual/RCUtil";
import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

class RCNavBtnDiv extends Component {

    static propTypes = {

        backBtnEnabled : PropTypes.bool,
        nextBtnEnabled : PropTypes.bool,

        divStyle       : PropTypes.object,

        showBackBtn    : PropTypes.bool,
        showNextBtn    : PropTypes.bool,

        onBackBtnClick : PropTypes.func,
        onNextBtnClick : PropTypes.func,

    };

    static defaultProps = {

        backBtnEnabled : true,
        nextBtnEnabled : true,

        divStyle       : {},

        showBackBtn    : true,
        showNextBtn    : true,

        onBackBtnClick : () => console.log("onBackBtnClick"),
        onNextBtnClick : () => console.log("onNextBtnClick"),

    };

    state = {

    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onBackBtnClick = () => {

        try {

            this.props.onBackBtnClick();

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onNextBtnClick = () => {

        try {

            this.props.onNextBtnClick();

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {

        const props = this.props;
        const showBackBtn = this.props.showBackBtn;
        const showNextBtn = this.props.showNextBtn;
        const backBtnEnabled = this.props.backBtnEnabled;
        const nextBtnEnabled = this.props.nextBtnEnabled;

        let backBtn = null;

        if (showBackBtn) {

            backBtn =
                <TButton
                    caption        = {RS(SC.GB_stBack)}
                    captionStyles  = {{
                        fontSize     : 16,
                        ...Theme.labelFontStyle,
                        marginTop    : 5,
                        marginBottom : 5,
                    }}
                    containerStyle = {{
                        display      : "inline-block",
                        fontFamily   : Theme.fontFamily,
                        marginBottom : 10,
                        marginLeft   : Theme.leftIndent,
                        marginTop    : Theme.topIndent,
                    }}
                    disabled       = {!backBtnEnabled}
                    key            = {"backBtn"}
                    style          = {{
                        backgroundColor : Theme.RC_SecondaryColor,
                        fontFamily      : Theme.fontFamily,
                    }}
                    onClick        = {this.onBackBtnClick}
                />;

        }

        let nextBtn = null;

        if (showNextBtn) {

            nextBtn =
                <TButton
                    caption        = {RS(SC.GB_stNext)}
                    captionStyles  = {{
                        fontSize     : 16,
                        ...Theme.labelFontStyle,
                        marginTop    : 5,
                        marginBottom : 5,
                    }}
                    containerStyle = {{
                        display      : "inline-block",
                        fontFamily   : Theme.fontFamily,
                        marginBottom : 20,
                        marginLeft   : Theme.leftIndent,
                        marginTop    : Theme.topIndent,
                    }}
                    disabled       = {!nextBtnEnabled}
                    key            = {"nextBtn"}
                    style          = {{
                        backgroundColor : Theme.RC_SecondaryColor,
                        fontFamily      : Theme.fontFamily,
                    }}
                    onClick        = {this.onNextBtnClick}
                />;

        }


        return (
            <div
                key   = {"RCNavBtnDiv"}
                style = {props.divStyle}
            >
                {backBtn}
                {nextBtn}
            </div>
        );

    }

}

export default RCNavBtnDiv;